module.exports = __webpack_public_path__ + "img/food-re-inspection.e8a898ba.png";